import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'

import './ChangeInfoForm.scss'

import TextInput from '../../../../components/Form/TextInput/TextInput'
import Toast from '../../../../components/Toast/Toast'
import UserRoleModal from '../../../../components/Modal/UserRoleModal/UserRoleModal'

import { API__USER } from '../../../../api'

const ChangeInfoForm = ({ userDetails, onSuccess = () => {}, t }) => {
    const [isLoading, setIsLoading] = useState(false)

    const [firstName, setFirstName] = useState(userDetails.firstName)
    const [lastName, setLastName] = useState(userDetails.lastName)
    const [company, setCompany] = useState(userDetails.company)
    const [isDisabledButton, setIsDisabledButton] = useState(false)

    const role = userDetails.roleInProjectDto

    useEffect(() => {
        if (
            userDetails.firstName !== firstName ||
            userDetails.lastName !== lastName ||
            userDetails.company !== company
        ) {
            setIsDisabledButton(false)
        } else {
            setIsDisabledButton(true)
        }
    }, [userDetails, firstName, lastName, company])

    const onSubmit = async () => {
        setIsLoading(true)
        try {
            const updatedUser = await API__USER.UPDATE_DETAILS(userDetails.id, {
                ...userDetails,
                firstName,
                lastName,
                company,
                roleInProjectDto: role,
            })
            await onSuccess(updatedUser)
            Toast('success', {
                message: t('Your profile information is updated successfully'),
            })
        } catch (err) {
            console.error(err)
            Toast('error', {})
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="form">
            <div className="form__inputs">
                <div className="form__inputs-block">
                    <TextInput label={t('Email')} isDisabled={true} value={userDetails.login} />
                </div>
                <div className="form__inputs-block">
                    <TextInput label={t('First name')} value={firstName} onUpdate={v => setFirstName(v)} />
                </div>
                <div className="form__inputs-block">
                    <TextInput label={t('Last name')} value={lastName} onUpdate={v => setLastName(v)} />
                </div>
                <div className="form__inputs-block">
                    <TextInput label={t('Company')} value={company} onUpdate={v => setCompany(v)} />
                </div>
                <div className="form__inputs-block">
                    <TextInput
                        label={t('Your role')}
                        value={
                            role
                                ? `${role.roleTranslationDto.text} (${role.userGroupInProjectDto.groupTranslationDto.text})`
                                : ''
                        }
                        isDisabled={true}
                    />
                </div>
            </div>
            <div className="form__buttons">
                <button
                    className="button"
                    data-size="md"
                    data-variant="primary"
                    disabled={isDisabledButton || isLoading}
                    onClick={() => onSubmit()}
                >
                    {t('Save changes')}
                </button>
            </div>
        </div>
    )
}

export default withTranslation('translations')(ChangeInfoForm)
